
import React, { Component } from "react";
import "./filterSidebar.css";

class FilterSidebar extends Component {
  state = {
    activeTab: "onlineFee",
  };

  setTab = (tab) => {
    this.setState({ activeTab: tab });
  };

  render() {
    const { activeTab } = this.state;
    const {
      params,
      filterCity,
      filterLanguages,
      changeGender,
      changeCity,
      changeFees,
      changePhysicalFees,
      changeLang,
      changeExp,
      applyFilter,
      closeFilter,
    } = this.props;

    return (
      <div className="filter-layout">
        {/* LEFT MENU */}
        <div className="filter-left">
          <ul>
            <li className={activeTab === "gender" ? "active" : ""} onClick={() => this.setTab("gender")}>Gender</li>
            <li className={activeTab === "city" ? "active" : ""} onClick={() => this.setTab("city")}>City</li>
            <li className={activeTab === "onlineFee" ? "active" : ""} onClick={() => this.setTab("onlineFee")}>Online Fee Range</li>
            <li className={activeTab === "physicalFee" ? "active" : ""} onClick={() => this.setTab("physicalFee")}>Physical Fee Range</li>
            <li className={activeTab === "languages" ? "active" : ""} onClick={() => this.setTab("languages")}>Languages</li>
            <li className={activeTab === "experience" ? "active" : ""} onClick={() => this.setTab("experience")}>Experience</li>
          </ul>
        </div>

        {/* RIGHT CONTENT */}
        <div className="filter-right">

          {activeTab === "gender" && (
            <div className="filter-section">
              <h3>Gender</h3>
              <label><input type="checkbox" name="gender" checked={params.gender.includes("M")} onChange={() => changeGender("M")} /> Male</label>
              <label><input type="checkbox" name="gender" checked={params.gender.includes("F")} onChange={() => changeGender("F")} /> Female</label>
            </div>
          )}

          {activeTab === "city" && (
            <div className="filter-section">
              <h3>City</h3>
              <div className="modal-scroll-container">
                {filterCity.map(city => (
                    <label key={city._id}>
                    <input type="checkbox" name="city" checked={params.cityId.includes(city._id)} onChange={() => changeCity(city._id)} />
                    {city.city}
                    </label>
                ))}
              </div>
            </div>
          )}

          {activeTab === "onlineFee" && (
            <div className="filter-section">
              <h3>Online Fee Range</h3>
              <label><input type="checkbox" name="onlineFee" checked={params.feesNumber.includes(1)} onChange={() => changeFees(1)} /> Lesser than 500 ₹</label>
              <label><input type="checkbox" name="onlineFee" checked={params.feesNumber.includes(2)} onChange={() => changeFees(2)} /> Between 500 and 700 ₹</label>
              <label><input type="checkbox" name="onlineFee" checked={params.feesNumber.includes(3)} onChange={() => changeFees(3)} /> Between 700 and 1000 ₹</label>
              <label><input type="checkbox" name="onlineFee" checked={params.feesNumber.includes(4)} onChange={() => changeFees(4)} /> Between 1000 and 1500 ₹</label>
              <label><input type="checkbox" name="onlineFee" checked={params.feesNumber.includes(5)} onChange={() => changeFees(5)} /> More than 1500 ₹</label>
            </div>
          )}

          {activeTab === "physicalFee" && (
            <div className="filter-section">
              <h3>Physical Fee Range</h3>
              <label><input type="checkbox" name="physicalFee" checked={params.physicalFee.includes(1)} onChange={() => changePhysicalFees(1)} /> Lesser than 500 ₹</label>
              <label><input type="checkbox" name="physicalFee" checked={params.physicalFee.includes(2)} onChange={() => changePhysicalFees(2)} /> Between 500 and 700 ₹</label>
              <label><input type="checkbox" name="physicalFee" checked={params.physicalFee.includes(3)} onChange={() => changePhysicalFees(3)} /> Between 700 and 1000 ₹</label>
              <label><input type="checkbox" name="physicalFee" checked={params.physicalFee.includes(4)} onChange={() => changePhysicalFees(4)} /> Between 1000 and 1500 ₹</label>
              <label><input type="checkbox" name="physicalFee" checked={params.physicalFee.includes(5)} onChange={() => changePhysicalFees(5)} /> More than 1500 ₹</label>
            </div>
          )}

          {activeTab === "languages" && (
            <div className="filter-section">
              <h3>Languages</h3>
              <div className="modal-scroll-container">
                {filterLanguages.map(l => (
                    <label key={l}>
                    <input type="checkbox" name="language" checked={params.language.includes(l)} onChange={() => changeLang(l)} />
                    {l}
                    </label>
                ))}
              </div>
            </div>
          )}

          {activeTab === "experience" && (
            <div className="filter-section">
              <h3>Experience</h3>
              <label><input type="checkbox" name="exp" checked={params.experienceNumber.includes(1)} onChange={() => changeExp(1)} /> Lesser than 2 years</label>
              <label><input type="checkbox" name="exp" checked={params.experienceNumber.includes(2)} onChange={() => changeExp(2)} /> Between 2 and 5 years</label>
              <label><input type="checkbox" name="exp" checked={params.experienceNumber.includes(3)} onChange={() => changeExp(3)} /> Between 5 and 10 years</label>
              <label><input type="checkbox" name="exp" checked={params.experienceNumber.includes(4)} onChange={() => changeExp(4)} /> Between 10 and 15 years</label>
              <label><input type="checkbox" name="exp" checked={params.experienceNumber.includes(5)} onChange={() => changeExp(5)} /> More than 15 years</label>
            </div>
          )}

          {/* ACTIONS */}
          <div className="filter-actions">
            <button className="apply" onClick={applyFilter}>Apply</button>
            <button className="cancel" onClick={closeFilter}>Cancel</button>
          </div>
        </div>
      </div>
    );
  }
}

export default FilterSidebar;

